import { Box } from "@mui/material";
import React from "react";
import ConnectionsView from "../views/Connections/ConnectionsView";
import PageTitle from "../base/PageTitle";

interface Props {}

const ConnectionsPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Connections" />
      <ConnectionsView />
    </Box>
  );
};

export default ConnectionsPage;
